import React from 'react';
import { Row } from '../../components/nucleus/Collection';
import StatusPill from '../../components/nucleus/StatusPill';

// ONE OF A MEMBERSHIP'S TWO CONTRACTS, as a row, the way Apps shows its one:
// what it is ("Shares into Studio"), how it stands (a pill: Active, Paused),
// what is in it ("Work, Photos"), and Open when there is a page for it. Every
// member holds both, admins too; sharing nothing is an empty contract, listed
// like any other.
export default function ContractRow({ name, sub, status, onOpen }) {
    const pill = status ? <StatusPill status={status} of="contract" /> : null;
    return (
        <Row
            name={pill ? <>{name} {pill}</> : name}
            sub={sub}
            end={onOpen ? 'Open' : undefined}
            onPress={onOpen || undefined}
        />
    );
}

// Where each contract opens. Yours with the group is a contract you own, so it
// opens among your own (personal space); the group's with a member is the
// group's, among its contracts.
export const shareContractPath = (epId) => `/realms/profiles?open=${encodeURIComponent(epId)}`;
export const accessContractPath = (groupId, epId) => `/group/${groupId}/realms/profiles?open=${encodeURIComponent(epId)}`;
